<template>
  <div class="trabalho-page">
    <rotate-square6 v-if="this.loading"></rotate-square6>
    <template v-if="!loading">
      <div class="trabalho-page__section">
        <Container>
          <div class="trabalho-page__header">
            <h1 class="trabalho-page__title" v-html="work.title.rendered"></h1>
            <p
              class="trabalho-page__client"
              v-html="work.cmb2['pt-work-mb']['pt-work-mb__client']"
            ></p>
            <div
              class="trabalho-page__description"
              v-html="work.excerpt.rendered"
            ></div>
            <img
              class="trabalho-page__back"
              :src="work.cmb2['pt-work-mb']['pt-work-mb__featured']"
              alt
            />
          </div>
        </Container>
      </div>
      <Section class="trabalho-page__triangle" fill="white" />
      <Container>
        <div class="trabalho-page__content trabalho-page__content--overlap">
          <template v-for="(image, id) in work.cmb2['pt-work-mb']['pt-work-mb__youtubes']">
            <youtube :video-id="image['pt-work-mb__youtube']"
                    :key="id"
                   ref="youtube"  style="border-radius: 1rem; position: relative; width: 100% !important;">
            </youtube>
          </template>
          <template
            v-for="(image, id) in work.cmb2['pt-work-mb']['pt-work-mb__media']"
          >
            <video v-if="image.split('.').pop() == 'mp4'" :key="id" autoplay>
              <source :src="image" type="video/mp4" />
            </video>
            <img v-else :key="id" :src="image" alt />
          </template>
        </div>
      </Container>
      <!-- <div class="trabalho-page__section">
        <div class="trabalho-page__middle">
          <h2 class="trabalho-page__subtitle">Médicos do Futuro</h2>
          <p class="trabalho-page__text">O I Simpósio de Excelência Operacional do Hospital Sírio-Libanês apresentou conceitos e experiências de sucesso na aplicação de metodologias de gestão. Nossa equipe criou a identidade visual do simpósio, peças de divulgação impressas e digitais, sinalização e cenografia.</p>
          <img class="trabalho-page__feat" src="https://placeimg.com/980/567/tech" alt="">
          <img class="trabalho-page__back" src="https://placeimg.com/1800/1500/tech" alt="">
        </div>
      </div>-->
      <!-- <Section class="trabalho-page__triangle" fill="white" inverted /> -->
      <Container>
        <!-- <div class="trabalho-page__content trabalho-page__content--overlap"> -->
        <div class="trabalho-page__content">
          <!-- <img v-for="i in [1, 2, 3, 4]" :key="i" :src="`https://placeimg.com/730/478/tech?${i}`" alt=""> -->
          <ButtonBox
            v-if="next"
            outline
            :to="{ name: 'trabalho', params: { slug: next.slug } }"
            >Próximo Trabalho</ButtonBox
          >
        </div>
        <div class="trabalho-page__relateds">
          <h3 class="trabalho-page__relateds-title">Trabalhos Relacionados</h3>
          <div
            v-for="related in random"
            :key="related.ID"
            class="trabalho-page__related"
          >
            <router-link
              :to="{ name: 'trabalho', params: { slug: related.slug } }"
            >
              <img
                class="trabalho-page__related-img"
                :src="
                  related.featured_media
                    ? related._embedded['wp:featuredmedia'][0].source_url
                    : require('@/assets/images/thumb.png')
                "
                :title="related.title.rendered"
                :alt="related.title.rendered"
              />
            </router-link>
            <h3 class="trabalho-page__related-title">
              <router-link
                :to="{ name: 'trabalho', params: { slug: related.slug } }"
              >
                <span v-html="related.title.rendered"></span>
              </router-link>
            </h3>
            <p
              class="trabalho-page__related-client"
              v-html="related.cmb2['pt-work-mb']['pt-work-mb__client']"
            ></p>
          </div>
        </div>
        <div class="trabalho-page__content">
          <ButtonBox outline :to="{ name: 'trabalhos' }"
            >Voltar para Portifólio</ButtonBox
          >
        </div>
      </Container>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

import Container from "@/components/Container";
import Section from "@/components/Section";
import ButtonBox from "@/components/ButtonBox";
import RotateSquare6 from "vue-loading-spinner/src/components/RotateSquare6";

export default {
  name: "trabalho",
  components: {
    Container,
    Section,
    ButtonBox,
    RotateSquare6
  },
  data: () => ({
    loading: true
  }),
  methods: {
    ...mapActions("works", ["find"])
  },
  computed: {
    ...mapState("works", {
      work: "item"
    }),
    ...mapGetters("works", ["random", "next"])
  },
  async created() {
    // await this.all();

    await this.find({
      slug: this.$route.params.slug
    });

    this.loading = false;
  },
  head: {
    title: {
      inner: "Branding, site, campanhas online e offline "
    },

    meta: [
      {
        name: "description",
        content:
          "Uma agência supercriativa com cases incríveis. Confira alguns dos trabalhos executados pela nossa equipe e traga o seu projeto para a Magor!",
        id: "desc"
      },
      {
        name: "og:description",
        content:
          "Uma agência supercriativa com cases incríveis. Confira alguns dos trabalhos executados pela nossa equipe e traga o seu projeto para a Magor!",
        id: "ogdesc"
      },
      {
        name: "keywords",
        content:
          "magor, design, gráfico, digital, propaganda, marketing, talento"
      }
    ]
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/vars";

.trabalho-page {
  &__section {
    position: relative;

    padding: 15rem 0 43.5rem;

    @media (max-width: $max-sm) {
      padding: 4.7rem 0 14.7rem;
    }
  }

  &__header {
    display: grid;
    align-items: center;

    color: #fff;

    gap: 1rem 3.5rem;
  }

  &__icon {
    width: 100%;

    grid-row: 1 / -1;

    @media (max-width: $max-sm) {
      align-self: start;
    }
  }

  &__title {
    font-size: 7rem;
    font-weight: 900;
    line-height: 1.2;

    @media (max-width: $max-sm) {
      font-size: 3rem;
    }
  }

  &__subtitle {
    font-size: 1.5rem;
    line-height: 1.2;

    @media (max-width: $max-sm) {
      margin: 0 25px;
    }

    @media (min-width: $min-md) {
      font-size: 2.5rem;

      align-self: end;

      text-align: right;

      grid-column-start: 2;
    }
  }

  &__text {
    font-size: 1.5rem;
    line-height: 1.6;

    color: #737373;

    @media (max-width: $max-sm) {
      margin: 0 25px;
    }

    @media (min-width: $min-md) {
      font-size: 1.8rem;

      align-self: start;

      text-align: right;

      grid-column-start: 2;
    }
  }

  &__client,
  &__description {
    font-size: 2rem;
    line-height: 1.2;

    @media (max-width: $max-sm) {
      font-size: 1.4rem;
    }
  }

  &__client {
    font-weight: 700;
  }

  &__back {
    position: absolute;
    z-index: -999;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    object-fit: cover;
  }

  &__triangle {
    position: relative;
    z-index: -10;

    margin-top: -28.5rem;

    @media (max-width: $max-sm) {
      margin-top: -5.7rem;
    }
  }

  &__content {
    display: grid;

    margin: 10rem 0;

    gap: 10rem;
    justify-items: center;

    @media (max-width: $max-sm) {
      gap: 4rem;
    }

    img,
    video {
      max-width: 100%;

      border-radius: 1rem;
    }

    &--overlap {
      margin-top: -28.5rem;

      @media (max-width: $max-sm) {
        margin-top: -5.7rem;
      }
    }
  }

  &__middle {
    display: grid;

    gap: 2.5rem;

    @media (min-width: $min-md) {
      grid-template-rows: auto auto;
      grid-template-columns: auto 25.5rem 98rem;

      gap: 2.2rem 12.5rem;
    }
  }

  &__feat {
    max-width: 100%;

    @media (max-width: $max-sm) {
      margin-left: 25px;
    }

    @media (min-width: $min-md) {
      grid-row: 1 / -1;
      grid-column-start: 3;
    }
  }

  &__relateds {
    display: grid;

    grid-template-columns: repeat(2, 1fr);

    gap: 2.8rem 1.7rem;

    @media (min-width: $min-md) {
      grid-template-columns: repeat(4, 1fr);

      gap: 8rem 3rem;
    }
  }

  &__relateds-title {
    font-size: 2.4rem;
    font-weight: 700;
    line-height: 1.2;

    text-align: center;

    grid-column: 1 / -1;

    @media (min-width: $min-md) {
      font-size: 3.5rem;
    }
  }

  &__related-img {
    width: 100%;

    border-radius: 0.9rem;
  }

  &__related-title {
    font-size: 1.7rem;
    line-height: 1.9rem;
    font-weight: 900;
    margin-top: 1.5rem;

    @media (min-width: $min-md) {
      font-size: 2.5rem;
      line-height: 2.7rem;
    }

    a {
      font: inherit;

      text-decoration: none;

      color: inherit;
    }
  }

  &__related-client {
    font-size: 1.4rem;
    line-height: 1.2;

    color: #9b9b9b;

    @media (min-width: $min-md) {
      font-size: 1.7rem;
    }
  }
}
</style>

<style lang="scss">
@import "../assets/css/vars";
.trabalho-page {
  &__description {
    a {
      font-weight: 700;

      text-decoration: none;

      &:link,
      &:visited {
        color: inherit;
      }

      &:hover,
      &:active {
        color: #ff3c3c;
      }
    }
  }
}
 @media (max-width: $max-xs) {
    iframe {
      height: 30vh !important;
    }
  }
  @media (min-width: $min-sm) {
    iframe {
      height: 45vh !important;
    }
  }
  @media (max-width: $max-md) {
    iframe {
      height: 65vh !important;
    }
  }
  @media (min-width: $min-lg) {
    iframe {
      height: 65vh !important;
    }
  }

</style>
